// Outlined counterpart to PlusIcon (a heavy filled glyph), as PencilIconOutline is to PencilIcon. The
// design ships a hardcoded #090F25; the stroke comes from currentColor so a menu row can tint it.
export default function PlusIconOutline({
  width = 17,
  height = 17,
  stroke = 'currentColor',
  ...rest
}: React.SVGProps<SVGSVGElement>) {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width={width} height={height} viewBox='0 0 17 17' fill='none' {...rest}>
      <path d='M0.5 8.5H16.5M8.5 0.5V16.5' stroke={stroke} strokeLinecap='round' strokeLinejoin='round' />
    </svg>
  );
}
